import { useRouter } from 'next/navigation'
import { datadogLogs } from '@datadog/browser-logs'
import { useGameActions, useGetCurrentGame } from 'src/store/game'
import { isMarbleGame, unknownGame } from 'src/types/domain/Game'
import { useUIActions, useGetIsTracksPanelOpen } from 'src/store/ui'
import { useSoundActions } from 'src/store/sound'
import { useGetCurrentPlayerId } from 'src/store/player'
import { ShowGames } from './ShowGames'

export function ShowGamesContainer() {
  const router = useRouter()
  const currentGame = useGetCurrentGame()
  const { tracksPanelOpened } = useUIActions()
  const isTracksPanelOpen = useGetIsTracksPanelOpen()
  const soundStoreActions = useSoundActions()
  const gameActions = useGameActions()
  const currentPlayerId = useGetCurrentPlayerId()

  const handleTrackClick = (gameId: string) => {
    tracksPanelOpened(false)
    soundStoreActions.clearAllNotifications()

    if (!isTracksPanelOpen) {
      router.push(`/${gameId}`)
    }

    if (isTracksPanelOpen && isMarbleGame(currentGame) && currentGame.id !== gameId) {
      gameActions.setCurrentGame(unknownGame)
      router.push(`/${gameId}`)

      datadogLogs.logger.info('tracks_panel', {
        user_action: {
          type: 'switch_game',
          currentGame: isMarbleGame(currentGame) ? currentGame.id : null,
          clickedGame: gameId,
          playerId: currentPlayerId
        }
      })
    }
  }

  return (
    <ShowGames
      currentGameId={isTracksPanelOpen && isMarbleGame(currentGame) ? currentGame.id : undefined}
      isTracksPanel={Boolean(isTracksPanelOpen)}
      onTrackClick={handleTrackClick}
    />
  )
}
